/**
 * Explanation section for the homepage button fields.
 * Shown as a distinct section heading in the hero editor and onboarding wizard.
 */
export default function HeroButtonPreview() {
  return (
    <div style={{
      margin: '24px 0 8px',
      paddingTop: '20px',
      borderTop: '1px solid #e2e8f0',
    }}>
      <h3 style={{
        margin: '0 0 6px',
        fontSize: '1em',
        fontWeight: 700,
        color: '#0f172a',
      }}>
        Homepage Button
      </h3>
      <p style={{
        margin: '0 0 16px',
        fontSize: '0.88em',
        color: '#475569',
        lineHeight: 1.6,
      }}>
        This is the main call-to-action on your homepage — the button visitors see right below your 
        headline. It's the most clicked element on most websites, so use it to guide people where you 
        want them to go (your products, contact page, booking link, etc.).
      </p>
      <p style={{
        margin: '0 0 4px',
        fontSize: '0.83em',
        color: '#64748b',
        lineHeight: 1.6,
      }}>
        For example: <strong>Button Text</strong> = <span style={{ 
          display: 'inline-block',
          background: '#14b8a6',
          color: '#fff',
          padding: '1px 8px',
          borderRadius: '4px',
          fontSize: '0.9em',
          fontWeight: 600,
        }}>Shop Now</span> and <strong>Button Link</strong> = <code style={{
          background: '#e2e8f0',
          padding: '1px 6px',
          borderRadius: '3px',
          fontSize: '0.9em',
        }}>/products</code> — visitors click "Shop Now" and land on your products page. Leave both blank to hide the button.
      </p>
    </div>
  );
}
